<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class="arch">
            <p>I can see the tide rise. I can anticipate each ebb and flow of water into brick and stone, an erosion that creeps towards time gone. Here it's visible as temporal gradients. Strata and stricture. </p>
            <p>I remember fragments from before, little slivers of memory slipped between the fog in my mind. They sting, cut and burrow and grate like sand when my attention passes toward them, working them lose. </p>
            <p>Only one moment.</p>
            <p>We walked here, marking streets and noting the instances for a child yet to be born. Then nothing, a grey zone over memories and suddenly clarity once more. </p>
            <p>A woman's laughter. A rush of water and a sluice gate opened, sending waterfowl into the air above a square in the sunlight. A cold light, early morning, the smell of coffee and baking bread. The cries of birds, screaming into the sky and.</p>
            <p>And nothing. </p>
            <p>A grey mist, threads of narrative that cannot be grasped or held. I imagine each one unfolding away from my hands as I reach for them, each strand slipping through my fingers. </p>
            <p>And then suddenly I am back here, a wharf below me, a dockside that apparently does not flood with the regularity of the one I remember. Wooden buildings surround it. Shambolic structures inviting the torch. Whatever was built there, it cannot have sailed far.
            and of this city I find it hard to choose what to write, what to remember.</p>
            <p>Sometimes, I think, I need new eyes to see this world. </p>
            <p></p>
            <p>I cut a hole in the paper of the book, I held it in front of my face and looked out across the city, the page as a camera, a frame to help me focus. </p>
            <p>I turned slowly, scanning the horizon, paying attention to each building, each person, each road that entered the frame,
            and the ones that felt important, the things I would want to tell her about, I wrote them down below the frame, fixing them in words</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'I Can See The Tides Rise'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
